import httpClient from './httpClient';

const prefix = '/system-permissions';
const rolsPrefix = '/rols';

export type SystemPermissionDto = {
  id: number;
  code: string;
  module: string;
  action: string;
  description: string;
};

export type RolePermissionAssignment = {
  code: string;
  scope: 'global' | 'branch' | 'own' | 'assigned';
};

export type RolePermissionMatrix = {
  roleId: number;
  roleCode: string | null;
  name: string;
  isSystem: boolean;
  isActive: boolean;
  grantsAllPermissions: boolean;
  structural: boolean;
  assignments: RolePermissionAssignment[];
};

export async function listSystemPermissions(): Promise<SystemPermissionDto[]> {
  return (await httpClient.get(prefix)).data;
}

export async function getRoleSystemPermissions(
  roleId: number,
): Promise<RolePermissionMatrix> {
  return (await httpClient.get(`${rolsPrefix}/${roleId}/system-permissions`))
    .data;
}

export async function replaceRoleSystemPermissions(
  roleId: number,
  permissions: RolePermissionAssignment[],
): Promise<RolePermissionMatrix> {
  return (
    await httpClient.put(`${rolsPrefix}/${roleId}/system-permissions`, {
      permissions,
    })
  ).data;
}
